import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Card Style (/cards). Anchors live in CardStylePage.tsx. */
export function getCardStyleTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Card Style',
        description:
          'Choose how your property cards and agent cards look across your whole site. Your ' +
          'choices save to your draft — publish your site to make them live.',
      },
    },
    {
      element: at('cards-listing'),
      popover: {
        title: 'Listing thumbnails',
        description:
          'These are the property cards on your home page and in search results. Click a style to ' +
          'use it — Classic is the default.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('cards-hover'),
      popover: {
        title: 'Hover to try it',
        description:
          'Move your mouse over a sample to see its effect. On your site, the accent comes from ' +
          'your own brand color.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: at('cards-agent'),
      popover: {
        title: 'Agent cards',
        description:
          'These are the cards on your agents page, showing each person’s photo, name, and ' +
          'contact details. Pick from Classic, Portrait, Row, Minimal, Overlay, or Framed.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
